import mapValues from 'lodash/mapValues';

import { RbacFeature } from '@evidentid/tprm-portal-lib/models/rbac/RbacFeature.model';
import { RbacRole } from '@evidentid/tprm-portal-lib/models/rbac/RbacRole.model';
import { RbacRoleDetails } from '@evidentid/tprm-portal-lib/models/rbac/RbacRoleDetails.model';

import {
    RBAC_FEATURE_PERMISSIONS_MAP,
} from '../../constants/feature-mappings/rbacFeaturePermissionsMap.constant';

function getAvailableFeaturesMapByPermissions(
    permissions: string[],
): Record<RbacFeature, boolean> {
    const permissionSet = new Set(permissions || []);
    return mapValues(
        RBAC_FEATURE_PERMISSIONS_MAP,
        (featureObj) => featureObj.requiredPermissions.every((required) => permissionSet.has(required)),
    );
}

export function getAvailableFeaturesMapByRole(
    roleName: RbacRole, roles: RbacRoleDetails[],
): Record<RbacFeature, boolean> {
    const role = roles.find((r) => r.name === roleName);
    if (role && role.permissions?.length > 0) {
        return getAvailableFeaturesMapByPermissions(role.permissions);
    } else {
        return {} as Record<RbacFeature, boolean>;
    }
}
